var request = require('request');

export default function EnvoiFormCB(phone, firstName, Name, emailClient, messageClient) {
 return new Promise(function(resolve, reject) {
  request({
     method:'POST',
     url:'https://artandgalleries-com-098c8a.appdrag.site/api/EnvoiForm', 
     form: {
      "phone" : phone,
      "firstName" : firstName,
      "Name" : Name,
      "emailClient" : emailClient,
      "messageClient" : messageClient
     }
  }, function(err,httpResponse,body) {
    if ( err != null ) { // si c'est une erreur alors renvoi ça
     resolve(err);
     
    }
    else { // si c'est autre chose affiche le
     resolve(body);
    
    }
  });
 });
}
